import flatpickr from "flatpickr";
import { useEffect, useRef } from "react";
import "flatpickr/dist/flatpickr.min.css";
import { FaTimes } from "react-icons/fa";

const DateTimePicker = ({
	onChange,
	value,
	placeholder,
	onClear,
	onFetch,
	isDisabled = false,
	dateError,
}) => {
	const dateTimeRef = useRef(null);

	useEffect(() => {
		const instance = flatpickr(dateTimeRef.current, {
			enableTime: true,
			dateFormat: "Y-m-d H:i",
			defaultDate: value,
			onChange: (selectedDates, dateStr, instance) => {
				if (selectedDates[0] && selectedDates[0].getTime() !== value?.getTime()) {
					onChange(selectedDates[0]);
				}
				instance.close();
			},
		});

		return () => instance.destroy();
	}, []);

	useEffect(() => {
		if (dateTimeRef.current && dateTimeRef.current._flatpickr) {
			const picker = dateTimeRef.current._flatpickr;
			const current = picker.selectedDates?.[0];

			if ((!value && !current) || (value && current && value.getTime() === current.getTime())) {
				return;
			}

			if (value) {
				picker.setDate(value, true);
			} else {
				picker.clear();
			}
		}
	}, [value]);

	const handleClear = () => {
		if (dateTimeRef.current && dateTimeRef.current._flatpickr) {
			dateTimeRef.current._flatpickr.clear();
		}
		onClear(null);
	};

	return (
		<div className={`relative w-full ${dateError ? "items-start" : ""}`}>
			<div className="relative">
				<>
					<input
						disabled={isDisabled}
						ref={dateTimeRef}
						type="text"
						placeholder={placeholder}
						className={`w-full rounded-md border bg-input-bg px-4 py-2 pr-10 text-sm placeholder-gray-400 transition-all ${isDisabled ? "cursor-not-allowed text-blue-gray opacity-60" : "text-white"}
      ${dateError ? "border-red-500 text-red-400 placeholder-red-300 focus:ring-red-500" : "border-blue-gray focus:ring-blue-500"}focus:outline-none focus:ring-2`}
					/>

					{value && (
						<FaTimes
							className={`-translate-y-1/2 absolute top-1/2 right-3 transform text-xl ${isDisabled ? "cursor-not-allowed text-blue-gray opacity-60" : "cursor-pointer text-white"}
    ${dateError ? "text-red-500 hover:text-red-700" : "text-gray-300 hover:text-white"}
  `}
							onClick={(e) => {
								if (!isDisabled) {
									e.stopPropagation();
									handleClear();
								}
							}}
						/>
					)}
				</>
			</div>{" "}
			{dateError && <p className="mt-1 font-medium text-red-500 text-sm">{dateError}</p>}{" "}
		</div>
	);
};

export default DateTimePicker;
